import React from 'react';
import { useSelector } from 'react-redux';
import { State } from 'model/State';
import { MACOrdersPage } from './OrdersPage';

// this component can be used to show a particular order
// and scrolled into view port using URL: `/purchase/my/billing/quotes/{orderId}?hash=:hash`
export const MACOrdersPreselectedPage = () => {
  const orderId = useSelector((state) => (state as State).location.payload.orderId);

  return <MACOrdersPage orderId={orderId} />;
};
